import React, { useState, useEffect } from 'react';
import { Card, Typography, Switch, InputNumber, Button, Statistic, Row, Col, message, Divider } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import api from '../api';

const { Title, Text } = Typography;

function CaptchaManagePage() {
  const [config, setConfig] = useState({ enabled: true, length: 4, expireSeconds: 300 });
  const [stats, setStats] = useState({ generated: 0, passed: 0, blocked: 0 });
  const [loading, setLoading] = useState(false);

  const load = async () => {
    try {
      const data = await api.get('/admin/captcha-config');
      setConfig(data.config || config);
      setStats(data.stats || stats);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const save = async () => {
    setLoading(true);
    try {
      await api.post('/admin/captcha-config', config);
      message.success('保存成功');
      load();
    } catch (e) {
      message.error('保存失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Title level={4}>图形验证码管理</Title>
      <Row gutter={24}>
        <Col span={12}>
          <Card title="配置（App 与后台登录均生效）">
            <div style={{ marginBottom: 16 }}>
              <Text>启用图形验证码</Text>
              <div style={{ marginTop: 8 }}>
                <Switch
                  checked={!!config.enabled}
                  onChange={(v) => setConfig({ ...config, enabled: v })}
                />
              </div>
            </div>
            <Divider />
            <div style={{ marginBottom: 16 }}>
              <Text>验证码长度：{config.length}</Text>
              <div style={{ marginTop: 8 }}>
                <InputNumber min={3} max={8} value={config.length} onChange={(v) => setConfig({ ...config, length: v })} />
              </div>
            </div>
            <Divider />
            <div style={{ marginBottom: 16 }}>
              <Text>过期时间（秒）：{config.expireSeconds}</Text>
              <div style={{ marginTop: 8 }}>
                <InputNumber min={60} max={600} step={30} value={config.expireSeconds} onChange={(v) => setConfig({ ...config, expireSeconds: v })} />
              </div>
            </div>
            <Divider />
            <Button type="primary" loading={loading} onClick={save} style={{ background: '#07C160' }}>
              保存配置
            </Button>
          </Card>
        </Col>
        <Col span={12}>
          <Card title="统计（重启服务后归零）">
            <Row gutter={16}>
              <Col span={8}><Statistic title="已生成" value={stats.generated} /></Col>
              <Col span={8}><Statistic title="通过" value={stats.passed} /></Col>
              <Col span={8}><Statistic title="拦截" value={stats.blocked} valueStyle={{ color: '#cf1322' }} /></Col>
            </Row>
            <Button icon={<ReloadOutlined />} style={{ marginTop: 16 }} onClick={load}>刷新统计</Button>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default CaptchaManagePage;
